// Full Duneworth lockup (D mark + DUNEWORTH wordmark) — used in hero
export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_disciplined-tech/artifacts/6wvrm1so_f1c2247a-1480-40e0-8040-ec83ae71cc16%20copy.png";

// D mark only — used in header nav and footer
export const LOGO_MARK_URL =
  "https://customer-assets.emergentagent.com/job_disciplined-tech/artifacts/fz6w4r9h_Mark%20only.png";

export const CONTACT_EMAIL = "duneworth@proton.me";

export const BRAND_TAGLINE = "Wall Street discipline. Silicon Valley innovation.";
export const BRAND_TAGLINE_DOTTED = "Wall Street discipline · Silicon Valley innovation";

export const PORTFOLIO = [
  {
    name: "Caddie Intel",
    url: "https://caddieintel.ai",
    domain: "caddieintel.ai",
    category: "Golf · Performance Intelligence",
    description:
      "AI-powered on-course intelligence — turning every round into structured data that helps golfers, coaches, and fitters make better decisions.",
    logo: "https://customer-assets.emergentagent.com/job_disciplined-tech/artifacts/zgiih6a7_extend-the-background-with-subtel-glow-a_fZaAW8l1SB6NUIdwjS5fnA_rRSVrCpNTNinMIGMuTZH5Q.png",
    logoBg: "bg-[#0a0a0a]",
  },
  {
    name: "Golf Nuts",
    url: "https://golfnutsofficial.com",
    domain: "golfnutsofficial.com",
    category: "Golf · Community & Culture",
    description:
      "A modern community and culture brand for golfers who love the game beyond the scorecard — built for distribution, content, and commerce.",
    logo: "https://customer-assets.emergentagent.com/job_disciplined-tech/artifacts/dng8ihb0_GN%20Logo%2016x9.jpg",
    logoBg: "bg-[#eceadf]",
  },
  {
    name: "Scramble Scout",
    url: "https://scramblescout.com",
    domain: "scramblescout.com",
    category: "Golf · Events & Marketplaces",
    description:
      "Discovery and booking infrastructure for golf scrambles, charity outings, and tournaments — connecting organizers with players at scale.",
    logo: "https://customer-assets.emergentagent.com/job_disciplined-tech/artifacts/f9p42hxy_Champions_Circle_Golf_Outing-1%20copy.png",
    logoBg: "bg-[#1a3a1f]",
  },
  {
    name: "ClipParrot",
    url: "https://clipparrot.com",
    domain: "clipparrot.com",
    category: "Software · Creator Operations",
    description:
      "AI content operations for short-form video — transcribing clips and generating on-brand, platform-native copy for creators, marketing teams, and agencies.",
    logo: "https://clipparrot.com/og-image.png",
    logoBg: "bg-[#e6692a]",
    objectPosition: "object-left",
  },
];

export const NAV_LINKS = [
  { label: "About", href: "/#about" },
  { label: "Portfolio", href: "/#portfolio" },
  { label: "Media", href: "/media" },
  { label: "Philosophy", href: "/#philosophy" },
  { label: "Contact", href: "/#contact" },
];

export const PILLARS = [
  {
    title: "Product Vision",
    body: "Modern software designed around how people actually behave — not how decks describe them.",
  },
  {
    title: "Operating Discipline",
    body: "Clear monetization, repeatable systems, and the patience to let durable models reveal themselves.",
  },
  {
    title: "Capital-Minded Execution",
    body: "Every company is built with enterprise value, scalability, and investor-readiness from day one.",
  },
];

export const FOCUS_AREAS = [
  { label: "Golf & Performance Technology" },
  { label: "Marketplaces & Booking Infrastructure" },
  { label: "Data & Intelligence Products" },
  { label: "Future Builds" },
];

export const PHILOSOPHY_STATEMENTS = [
  "Focused products over bloated platforms.",
  "Durable revenue over vanity metrics.",
  "Elegant systems over unnecessary complexity.",
  "Long-term ownership over short-term noise.",
  "Patience over hype.",
];


export const MEDIA_SUPPORTS = [
  {
    title: "Brand & Product Positioning",
    body:
      "Clear messaging around what a product is, who it serves, why it matters, and how it should be understood in the market.",
  },
  {
    title: "Content Creation",
    body:
      "Photography, video, short-form content, product visuals, founder-led content, lifestyle creative, and campaign assets.",
  },
  {
    title: "Launch & Campaign Support",
    body:
      "Go-to-market materials, landing page direction, email creative, social campaigns, product announcements, and supporting content systems.",
  },
  {
    title: "Digital Storytelling",
    body:
      "Narrative-driven content that helps explain products, build trust, and make technology feel more useful, human, and accessible.",
  },
  {
    title: "Marketing Operations",
    body:
      "The practical execution layer that helps turn ideas into usable assets across websites, emails, social platforms, sales materials, and customer touchpoints.",
  },
];